export const flattenObjectToArray = (originalObject) => (
  Array.isArray(originalObject)
    ? originalObject
    : Object.keys(originalObject).reduce((arraySoFar, curKey) => [...flattenObjectToArray(originalObject[curKey]), ...arraySoFar], []))

export const flatten = (originalArray) => originalArray.reduce((arraySoFar, currentElem) => arraySoFar.concat(Array.isArray(currentElem) ? flatten(currentElem) : currentElem), [])
